import * as Sentry from "@sentry/react";

/**
 * Same error/trace capture as a plain Sentry.init(), but Session Replay's
 * DOM-observer setup is deferred to idle time instead of competing with
 * initial render/interactivity — Replay only ever records on/after an
 * error (replaysOnErrorSampleRate) plus a small always-on sample
 * (replaysSessionSampleRate), so nothing is lost by starting it a beat
 * later. No-ops if dsn is unset (local dev).
 */
export function initSentry(app: string, dsn: string | undefined, environment: string): void {
  Sentry.init({
    dsn,
    environment,
    initialScope: { tags: { app } },
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  const loadReplay = () => Sentry.addIntegration(Sentry.replayIntegration());
  if (typeof requestIdleCallback === "function") requestIdleCallback(loadReplay, { timeout: 4000 });
  else setTimeout(loadReplay, 2000);
}
